<template>
  <div class="add-to-cart">
    <button
      class="secondary-gradient cta-btn pulse"
      type="button"
  	  data-qa=”tryAndBuyButton”
      :disabled="(subscription.status === 'active' && new Date() > new Date(subscription.current_period_end)) || subscription.status === 'inactive' || subscription.status === 'validation pending'"
      @click="
        addToCart()
      "
    >
      BUY & TRY
    </button>
  </div>
</template>

<script>
import publicIpAddress from 'public-ip'

export default {
  name: 'add-to-cart',
  props: {
    name: String,
    price: String,
    quantity: String,
    pImage: String,
    pId: String,
    subscription: Object,
    productData: Object
  },
  data() {
    return {
      item: {
        productName: this.name,
        productImage: this.pImage,
        productPrice: this.price,
        product_Id: this.pId,
        productQuantity: 1
      }
    }
  },
  methods: {
    async addToCart() {
      const timeResponse = await this.getTime()
      if (
        this.productData.type &&
        this.productData.type.toLowerCase().trim() === 'alcoholic' &&
        (timeResponse.hour >= 21 || timeResponse.hour <= 6)
      ) {
        this.allowToSell = false
        alert('Not allowed to sell after 9 pm. Try again tomorrow from 7 am')
      } else {
        this.$store.commit('addToCart', this.item)
        const user = JSON.parse(localStorage.getItem('user'));
        if(user && localStorage.getItem('token') && (user.role === 'user' || user.role === 'guest')) {
          this.$emit('open-modal', {type: 'miniCart', flow: 'non-shippable'})
        } else {
          this.$emit('open-modal', {type: 'loginModal', flow: 'non-shippable'})
        }
      }
    },
    async getTime() {
      const publicIp = await publicIpAddress.v4()
      return new Promise((resolve, reject) => {
        this.$store.dispatch('timeapi', publicIp)
        .then((response) => {
          const datetime = response.data
          return resolve(datetime)
        }).catch(error => {
          return reject(error)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-to-cart {
	margin: 0;
	padding: 0;
}
.cta-btn {
	background: linear-gradient(to right, #fb7377, #c95c5f);
	// width: 100%;
	padding: 5px;
	color: white;
	// margin-top: 5px 10px 50px 10px;
	align-items: center;
	justify-content: space-between;
	height: 52px;
	border: none;
	border-radius: 5px;
	font-size: 1.4em;
	text-align: center;
	// letter-spacing: 0.4rem;
	text-transform: uppercase;
	font-weight: 500;
	// white-space: nowrap;
  transition: all 0.2s linear;
}

.cta-button:hover {
	transform: scale(1);
	box-shadow: none;
//   background: linear-gradient(to right, #f7921ec9, #c46428a8);
}

.cta-button:active {
	animation: pulse 0.25s infinite ease-out;
	background: linear-gradient(to right, #fb7377, #c95c5f);
}

.cta-button:focus {
	outline: 0;
}
.cta-button:disabled {
	-webkit-transform: scale(1);
	transform: scale(1);
	box-shadow: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
</style>
